import React from 'react';
import StandardButton from '../app_components/StandardButton';

const ProfileAcceptConnect = () => (
  <div className="profile-actions">
    <StandardButton
      primary
      size="large"
      fullWidth
      text="Accept Connect Request"
      onClick={() => { window.location.href = '/connects'; }}
    />
  </div>
);

export default ProfileAcceptConnect;
